import React, { useState } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const warningMessage = `If you revoke it, all kinds of automation including WORKFLOWS, WIDGETS,
            BUTTONS , RELATED LIST and SETTINGS will be DISABLED`;
function RevokeDialog(props) {
  const { service, handleRevokeService } = props;
  const [revokeOpen, setRevokeOpen] = useState(false);

  const handleClickRevokeOpen = () => {
    setRevokeOpen(true);
  };

  const handleRevokeClose = () => {
    setRevokeOpen(false);
  };

  return (
    <>
      <Button
        size="small"
        variant="contained"
        color="error"
        onClick={handleClickRevokeOpen}
        sx={{ boxShadow: "none" }}
      >
        Revoke
      </Button>
      <Dialog
        open={revokeOpen}
        onClose={handleRevokeClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Do you want to revoke ${service.toUpperCase()} connection?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {warningMessage.toUpperCase()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleRevokeClose}
            autoFocus
            variant="contained"
            color="success"
          >
            Dont Revoke
          </Button>
          <Button
            onClick={handleRevokeService}
            variant="outlined"
            color="error"
          >
            I want to revoke {service.toUpperCase()}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RevokeDialog;
